(function () {
  'use strict';

  var KEY = 'sd_partner_estimate';
  var root = document.querySelector('[data-sd-partner-apply]');
  if (!root) return;

  function read() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function paint() {
    var data = read();
    var amount = root.querySelector('[data-sd-partner-estimate-amount]');
    var profile = root.querySelector('[data-sd-partner-estimate-profile]');
    var field = root.querySelector('[data-sd-partner-estimate-field]');
    var annual = data && data.annual ? data.annual : '£4,440';
    var name = data && data.profile ? data.profile : 'Busy dry cleaner';

    if (amount) amount.textContent = annual;
    if (profile) profile.textContent = name;
    if (field) field.value = annual + ' / year · ' + name;
  }

  paint();
  window.addEventListener('sd:partner-estimate', paint);
})();
